import {
  Box,
  Typography,
  makeStyles,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { Modal, colors } from 'design-system';

const useStyles = makeStyles(() => ({
  fontSubtitle: {
    fontSize: 15,
    lineHeight: '22px',
    fontWeight: 400,
    letterSpacing: '.1px',
    color: '#0D2E68',
  },
  whatsappButton: {
    color: colors.bright_turquoise,
    fontWeight: 500,
    verticalAlign: 'bottom',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

type Props = {
  onClose: () => void;
  open: boolean;
  message?: string;
};

const PersonValidationModal = ({
  open,
  onClose,
  message = 'Hemos validado el número de identificación y no podemos continuar con la emisión de la póliza por este medio.',
}: Props): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Modal
      data-testid="swi-person-validation-modal"
      title="¡Importante!"
      open={open}
      maxWidth="sm"
      onCloseRequested={onClose}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: '10px',
          mb: '15px',
        }}
      >
        <img alt="" src="/svg/validation_error.svg" />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mb: '25px',
          mr: isMobile ? 0 : 4,
          ml: isMobile ? 0 : 4,
        }}
        data-testid="info-container"
      >
        <Box sx={{ maxWidth: '416px' }}>
          <Typography align="center" className={classes.fontSubtitle}>
            {message}
          </Typography>
          <br />
          <Typography align="center" className={classes.fontSubtitle}>
            Por favor, chatéanos al{' '}
            <a
              data-testid="whatsapp-button"
              href="https://wa.me/50625032772"
              target="_blank"
              className={classes.whatsappButton}
              rel="noreferrer"
            >
              WhatsApp (506) 2503-2772
            </a>{' '}
            para solicitar de nuestra asistencia y continuar con el proceso.
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};

export default PersonValidationModal;
